import {ChangeDetectionStrategy, Component, Input, OnInit} from '@angular/core';
import {HandoverModel} from "@handover/view-models/handover.model";

@Component({
  selector: 'handoverm-handover-signature',
  templateUrl: './handover-signature.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HandoverSignatureComponent implements OnInit {

  @Input() model?: HandoverModel;

  constructor() {
  }

  ngOnInit(): void {
  }

}
